import * as React from "react";
import { Button } from "./Button";
import ACTIONS from "./EventLibrary";
import { rudderStackTrack } from "./Track";
import { Flex } from "@radix-ui/themes";

const TYPE_MAP = {
    operator: {
        h3: "Interested in helping the Covalent Network grow?",
        p: "Apply to become a Covalent Network Operator today.",
        button: "Learn More",
        href: "https://docs.google.com/forms/d/1zf_l6sbxGD9THQeOgXGRYK91ndgrcIFGQ97HFSGhCPk/"
    },
    validator: {
        h3: "Interested in helping the Covalent Network grow?",
        p: "Stake and earn CQT and help build the decentralized protocol.",
        button: "Go To the Staking Dashboard",
        href: "https://www.covalenthq.com/staking/"
    },
    governance: {
        h3: "Interested in helping the Covalent Network grow?",
        p: "Govern the Covalent network with CQT and help build the decentralized protocol.",
        button: "Go To the Governance Forums",
        href: "https://gov.covalenthq.com/"
    }
};

export function NetworkCTA({ type }) {
    return <div className="cta">
        <div className="content">
            <Flex direction="column" gap="3">
                <h3>{TYPE_MAP[type].h3}</h3>
                <p>{TYPE_MAP[type].p}</p>
            </Flex>
            <Button onClick={()=>{ rudderStackTrack(ACTIONS.docs_networkcta_clicked, { value : TYPE_MAP[type].href, type: type || "default" }); }} target="_blank" rel="noreferrer noopener" href={TYPE_MAP[type].href}>{TYPE_MAP[type].button}</Button>
        </div>
        <style jsx>
            {`
            .cta {
                margin-bottom: var(--default-vertical-spacing);
            }
            h3 {
                margin-top: 0rem;
                margin-bottom: 0rem;
            }
            .content {
                color: var(--dark);
                background: var(--code-background);
                border: 1px solid var(--code-border);
                line-height: 20px;
                padding: 1.5rem;
                border-radius: var(--border-radius);
                display: flex;
                justify-content: space-between;
              }
            `}
        </style>
    </div>;
}
